import { render, staticRenderFns } from "./parcel-book.vue?vue&type=template&id=5f1783cc"
import script from "./parcel-book.vue?vue&type=script&lang=js"
export * from "./parcel-book.vue?vue&type=script&lang=js"
import style0 from "./parcel-book.vue?vue&type=style&index=0&id=5f1783cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports